import { Container } from "@chakra-ui/react";
import styles from "./frontpage.module.scss";
import Video from "./Video";

const FrontPage = () => {
  return (
    <div className={styles.pageContainer} id="home">
      <Video />
      <Container className={styles.frontContainer}>
        <h4>The future of lean biotech manufacturing</h4>
      </Container>
    </div>
  );
};

export default FrontPage;
